import { render, staticRenderFns } from "./negativeKeyword.vue?vue&type=template&id=05a87d37&scoped=true"
import script from "./negativeKeyword.vue?vue&type=script&lang=js"
export * from "./negativeKeyword.vue?vue&type=script&lang=js"
import style0 from "./negativeKeyword.vue?vue&type=style&index=0&id=05a87d37&prod&lang=scss&scoped=true"
import style1 from "./negativeKeyword.vue?vue&type=style&index=1&id=05a87d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a87d37",
  null
  
)

export default component.exports